import React from "react";
import TileSubPanel from "components/TileSubPanel";
import StructureListCard from "./StructureListCard";

const StructureList = (props) => {
    const { farm, budget, refData } = props;

    const structuresWithDistributedSupplements = (budget.structures || []).filter((s) => {
        return (budget.feedSupplements || []).some((fs) => (fs.destinations || []).some((d) => d.structureId === s.id));
    });

    return (
        <div>
            {structuresWithDistributedSupplements && structuresWithDistributedSupplements.length > 0 && (
                <TileSubPanel title="Structures" green stickyHeaderName="budget.supplements.structures.collapsed">
                    {structuresWithDistributedSupplements.map((structure) => (
                        <StructureListCard key={structure.id} farm={farm} budget={budget} structure={structure} refData={refData} />
                    ))}
                </TileSubPanel>
            )}
        </div>
    );
};

export default StructureList;
